import { adminsConstants } from "../_constants";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

export const adminUsersAction = {
    adminUsersList,
    getNewEmployeeIdByPromise,
    createAdminUserByPromise,
    getAdminAccessByPromise,
    updateAdminUserAccessByPromise,
    activeOrInactiveAdminUserByPromise,
    updateAdminPasswordPromise
};

function adminUsersList(data, details) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/admin/adminUserList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return { type: adminsConstants.GET_ADMIN_USER_LIST_REQUEST, user };
    }
    function success(user) {
        return { type: adminsConstants.GET_ADMIN_USER_LIST_SUCCESS, user };
    }
    function failure(error) {
        return {
            type: adminsConstants.GET_ADMIN_USER_LIST_FAILURE,
            error,
        };
    }
};

function getNewEmployeeIdByPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/getNewEmployeeId'
    }
    return APIcallFunction(credentials)
}

function createAdminUserByPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/createAdminUser'
    }
    return APIcallFunction(credentials)
}

function getAdminAccessByPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/getAdminAccess'
    }
    return APIcallFunction(credentials)
}

function updateAdminUserAccessByPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/updateAdminUserAccess'
    }
    return APIcallFunction(credentials)
}

function activeOrInactiveAdminUserByPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/activeOrInactiveAdminUser'
    }
    return APIcallFunction(credentials)
}

function updateAdminPasswordPromise(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: '/admin/updateAdminPassword'
    }
    return APIcallFunction(credentials)
}